// React
import React from 'react';

// Libs
import { Icon } from 'semantic-ui-react';

// Types
interface CopyContentComponentProps {
    children: string | React.ReactText;
}

/**
 * Copy button component. It uses the "children" as value.
 *
 * @param props CopyContentComponentProps
 * @returns React.ReactElement
 */
export default function CopyContentComponent(props: CopyContentComponentProps): React.ReactElement {
    const value = props.children ? props.children.toString().trim() : '';

    function onCopy() {
        navigator.clipboard.writeText(value);
    }

    return (
        <>
            {value && <Icon name="copy outline" onClick={onCopy} style={{ cursor: 'copy' }} />}
            {' ' + value}
        </>
    );
}
